import { render, staticRenderFns } from "./SimpleFiledropper.vue?vue&type=template&id=394220e6&scoped=true&"
import script from "./SimpleFiledropper.vue?vue&type=script&lang=js&"
export * from "./SimpleFiledropper.vue?vue&type=script&lang=js&"
import style0 from "./SimpleFiledropper.vue?vue&type=style&index=0&id=394220e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394220e6",
  null
  
)

export default component.exports